import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input-forms-popup',
  templateUrl: './input-forms-popup.component.html',
})
export class InputFormsPopupComponent {
  @Input() buttonId: string = 'decPopup';
  @Input() modalId: string = 'dec_popup';
  @Input() closeId: string = 'student_security_haschanges_popclose';
  @Input() closeIconPath: string = '/assets/images/close_circle.svg';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() cancelButtonId: string = 'cancel-button';
  @Input() confirmButtonId: string = 'confirm-button';
  @Input() cancelText: string = 'Cancel';
  @Input() confirmText: string = 'Save';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}